import { ExemplosHorizontalFieldModel } from '@mchat-rf/consulta-seguimento/components/ExemplosHorizontalField'
import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoOutroFieldModel,
} from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export interface ConsultaSeguimentoPergunta05Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_05_HEADER?: SimNaoEnum
  PERGUNTA_05_EXEMPLOS?: ExemplosHorizontalFieldModel<ConsultaSeguimentoPergunta05ExemplosEnum>
  PERGUNTA_05_DUAS_VEZES_POR_SEMANA?: SimNaoEnum
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}

export enum ConsultaSeguimentoPergunta05ExemplosEnum {
  OLHA_PARA_AS_MAOS = 'OLHA_PARA_AS_MAOS',
  MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO = 'MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO',
  MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS = 'MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS',
  MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS = 'MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS',
  MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS = 'MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS',
  AGITA_AS_MAOS_PERTO_DO_ROSTO = 'AGITA_AS_MAOS_PERTO_DO_ROSTO',
}
